import type { EditableSettings } from "./settings-form";
import type { SettingsSnapshot } from "./types";

export interface ReconciledCharacterMetadata {
  saved: SettingsSnapshot;
  values: EditableSettings;
}

export function reconcileCharacterMetadata(saved: SettingsSnapshot, values: EditableSettings, snapshot: SettingsSnapshot): ReconciledCharacterMetadata {
  const unlockedNames = new Set(snapshot.unlocked_personas.map((persona) => persona.name));
  const hasUnsavedPersonaSelection = values.selected_persona !== saved.selected_persona;
  const keepUnsavedPersonaSelection = hasUnsavedPersonaSelection && unlockedNames.has(values.selected_persona);
  return {
    saved: {
      ...saved,
      selected_persona: snapshot.selected_persona,
      unlocked_personas: snapshot.unlocked_personas,
      context: snapshot.context,
      persona_available: snapshot.persona_available,
      has_locked_personas: snapshot.has_locked_personas ?? true,
    },
    values: {
      ...values,
      selected_persona: keepUnsavedPersonaSelection ? values.selected_persona : snapshot.selected_persona,
    },
  };
}
